
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map, switchMap, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';






import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class LoanOperationService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }
    // Searching through Loan Application table
    searchForLoan(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchForLoanByCallLimit(term)),);
    }

    searchForLoanByCallLimit(term) {
        return this.http
            .get(`creditoperations/loan-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }

    searchForInactiveLoanContingent(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchLoanForInactiveContingent(term)),);
    }
    searchLoanForInactiveContingent(term) {
        return this.http
            .get(`creditoperations/loan-search-inactive-contingent?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }

    fullAndFinalLoanSearch(searchQuery) {
        return this.http.get(`creditoperations/loan-search/full-and-final/${searchQuery}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    // cancelFullAndFinal(loanId) {
    //     return this.http.get(`creditoperations/cancel-full-and-final/${loanId}`)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));

    // }

    cancelFullAndFinal(loanId,statusId) {
        return this.http.get(`creditoperations/cancel-full-and-final/${loanId}/status/${statusId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }


    getApprovedOverDraftRouteAndReviewApplication() {
        return this.http
            .get(`creditoperations/approved-overdraft-route-and-review-application`).pipe(
            map((res: any) => res));
    }


    searchForLoanContingent(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchLoanForContingent(term)),);
    }
    searchLoanForContingent(term) {
        return this.http
            .get(`creditoperations/loan-search-contingent?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }
    searchForLoanPrepayment(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchLoanForPrepayment(term)),);
    }

    searchLoanForPrepayment(term) {
        return this.http
            .get(`creditoperations/loan-search-prepayment?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }

    searchForFXRevolvingLoan(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchForFXRevolvingLoanByFilter(term)),);
    }

    searchForFXRevolvingLoanByFilter(term) {
        return this.http
            .get(`creditoperations/fx-revolving-loan-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }

    searchForRunningCommercialAndFxLoans(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchForRunningCommercialAndFxLoanByQuery(term)),);
    }

    searchForRunningCommercialAndFxLoanByQuery(term) {
        return this.http
            .get(`creditoperations/running-commercial-and-fx-loan-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }
    searchForOD(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.searchForODByCallLimit(term)),);
    }

    searchForODByCallLimit(term) {
        return this.http
            .get(`creditoperations/overdraft-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }

    getApprovedContingentTerminationApplication() {
        return this.http
            .get(`creditoperations/contingent-for-termination-application`).pipe(
            map((res: any) => res));
    }
    getApprovedContingentApplication() {
        return this.http
            .get(`creditoperations/approved-contingent-application`).pipe(
            map((res: any) => res));
    }

    getApprovedOverDraftReviewApplication() {
        return this.http
            .get(`creditoperations/approved-overdraft-review-application`).pipe(
            map((res: any) => res));
    }

    getContingentByLoanId(revolvingLoanId: number) {
        return this.http
            .get(`creditoperations/contingent-detail?revolvingLoanId=${revolvingLoanId}`).pipe(
            map((res: any) => res));
    }


    runRefressFinacleBulkPosting(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`admin/end-of-day-RepaymentFromStagin`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    // runRefressFinacleBulkPosting(revolvingLoanId: number) {
    //     return this.http
    //         .get(`admin/end-of-day-RepaymentFromStagin?revolvingLoanId=${revolvingLoanId}`)
    //         .map((res: any) => res);
    // }
    
    getOverDraftDetailsByLoanId(revolvingLoanId: number) {
        return this.http
            .get(`creditoperations/overdraft-detail?revolvingLoanId=${revolvingLoanId}`).pipe(
            map((res: any) => res));
    }

    getApprovedLoanReview() {
        return this.http
            .get(`creditoperations/approved-loan-review`).pipe(
            map((res: any) => res));
    }
  getApprovedNonTermLoansForReviewAwaitingApproval() {
        return this.http
            .get(`creditoperations/approved-non-term-loan-review-approval`).pipe(
            map((res: any) => res));
    }
    getApprovedNonTermLoansForReview() {
        return this.http
            .get(`creditoperations/approved-non-term-loan-review`).pipe(
            map((res: any) => res));
    }

    getApprovedLineReviewData() {
        return this.http
            .get(`creditoperations/approved-line-review`).pipe(
            map((res: any) => res));
    }
    getApplicationLineTenorChangeAwaitingApproval() {
        return this.http
            .get(`operations/line-operation-awaiting-approval`).pipe(
            map((res: any) => res));
    }

    
    getCommercialLoanByApplicationDetailId(loanApplicationDetailId) {
        return this.http
            .get(`loan/commercial-loans/application-detail/${loanApplicationDetailId}`).pipe(
            map((res: any) => res));
    }

    getApprovedFXRevolvingLoanReview() {
        return this.http
            .get(`creditoperations/approved-fx-revolving-loan-review`).pipe(
            map((res: any) => res));
    }

    getApprovedLoanReviewRemedial() {
        return this.http
            .get(`creditoperations/approved-loan-review-remedial`).pipe(
            map((res: any) => res));
    }

    getDisbursedLoanDetailsById(loanId, loanType) {
        return this.http
            .get(`creditoperations/disbursed-loan-details?loanId=${loanId}&loanType=${loanType}`).pipe(
            map((res: any) => res));
    }
    getUnDisbursedLoanDetailsById(loanId, loanType) {
        return this.http
            .get(`creditoperations/undisbursed-loan-details?loanId=${loanId}&loanType=${loanType}`).pipe(
            map((res: any) => res));
    }
    getDisbursedCommercialLoanTrancheDetailsById(loanId) {
        return this.http
            .get(`creditoperations/disbursed-loan-tranche-details/${loanId}`).pipe(
            map((res: any) => res));
    }

    getGroupCustomerLoanByLoanId(loanId) { 
        return this.http
            .get(`creditoperations/group-customer-loan-details?loanId=${loanId}`).pipe(
            map((res: any) => res));
    }

    getOperationType() {
        return this.http
            .get(`creditoperations/loan-operationtype`).pipe(
            map((res: any) => res));
    }
    getReviewApprovalOperations() {
        return this.http
            .get(`creditoperations/loan-operationtype`)
            .map((res: Response) => res.json());
    }
    

    getOperationTypeByOD() {
        return this.http
            .get(`creditoperations/loan-operationtypebyoverdraft`).pipe(
            map((res: any) => res));
    }

    getOperationTypeByContingent() {
        return this.http
            .get(`creditoperations/loan-operationtypebycontingent`).pipe(
            map((res: any) => res));
    }

    getRemedialOperationType() {
        return this.http
            .get(`creditoperations/loan-remedial-operationtype`).pipe(
            map((res: any) => res));
    }

    getOperationTypeByScheduleId(proId, schId) {
        return this.http
            .get(`creditoperations/loan-operationtype?productTypeId=${proId}&scheduleTypeId=${schId}`).pipe(
            map((res: any) => res));
    }

    // getLoanGuarantors(loanId) {
    //     return this.http
    //         .get(`creditoperations/loan-guarantor?loanId=${loanId}`)
    //         .map((res: any) => res);
    // }

    getLoanConvenant(loanId) {
        return this.http
            .get(`creditoperations/loan-convenant?loanId=${loanId}`).pipe(
            map((res: any) => res));
    }

    getLoanChargeFee(loanId) {
        return this.http
            .get(`creditoperations/loan-chargefee?loanId=${loanId}`).pipe(
            map((res: any) => res));
    }

    getLoanCollateralOD(loanId,loanType) {
        return this.http
            .get(`creditoperations/loan-collateral-od?loanId=${loanId}&loanType=${loanType}`).pipe(
            map((res: any) => res));
    }

    getLoanCollateral(loanId) {
        return this.http
            .get(`creditoperations/loan-collateral?loanId=${loanId}`).pipe(
            map((res: any) => res));
    }

    getLoanCollateralByProductType(loanId, productTypeId) {
        return this.http
            .get(`credit/customer-collateral/loan/${loanId}/productTypeId/${productTypeId}`).pipe(
            map((res: any) => res));
    }

    getLoanCollateralByCustomerId(customerId) {
        return this.http
            .get(`credit/customer-collateral/active/${customerId}`).pipe(
            map((res: any) => res));
    }

    getApprovedLoanReviewAwaitingOperation() {
        return this.http
            .get(`creditoperations/approved-loan-review-awaiting-operation`).pipe(
            map((res: any) => res));
    }
    
    getLoanConvenantOD(loanId,loanType) {
        return this.http
            .get(`creditoperations/loan-convenant-od?loanId=${loanId}&loanType=${loanType}`).pipe(
            map((res: any) => res));
    }

    getLoanChargeFeeOD(loanId,loanType) {
        return this.http
            .get(`creditoperations/loan-chargefee-od?loanId=${loanId}&loanType=${loanType}`).pipe(
            map((res: any) => res));
    }

    getLoanScheduleByLoanId(loanId) {
        return this.http
            .get(`creditoperations/loan-schedule-details?loanId=${loanId}`).pipe(
            map((res: any) => res));
    }

    getAllLoanOperationAwaitingApproval() {
        return this.http.get(`creditoperations/loan-operation/awaiting-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanReviewOperationIrregularSchedule(id) {
        return this.http.get(`operations/loan-review-irregular-schedule/${id}`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllApprovedLoanReview() {
        return this.http.get(`creditoperations/loan-operation/approved-loan-review`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanApprovalDetails(loanId, operationId) {
        return this.http.get(`creditoperations/loan-operation/approval-detail?loanId=${loanId}&operationId=${operationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addLoanContingent(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`creditoperations/add-loan-contingent`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    // addLoanContingentWithAttachment(file: File, body: any) {
    //     let bodyObj = JSON.stringify(formObj);
    //     return this.http.post(`creditoperations/add-loan-contingent`, bodyObj)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    addLoanContingentWithAttachment(file: File, body: any) {
        let bodyObj = JSON.stringify(body);

        return new Promise((resolve, reject) => {

            let url = `creditoperations/add-loan-contingent-with-attachment`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();

            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);


            xhr.send(formData);
        });
    }


    addLoanReviewOperation(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`creditoperations/add-loan-review`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    sendLoanOperationForApproval(formObj) {
        return this.http.post(`creditoperations/operation-approval`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    sendLoanOperationRephrasement(formObj) {
        return this.http.post(`creditoperations/operation-loan-rephrasement`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getMaturedCommercialLoansParent() {
        return this.http.get(`operations/commercial-loans-lines`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getdueCommercialLoansByApplicationDetailId(loanApplicationDetailId) {
        return this.http.get(`operations/due-commercial-loans/detail/${loanApplicationDetailId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getdueCommercialLoans() {
        return this.http.get(`operations/due-commercial-loans`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getRunningCommercialLoanLines() {
        return this.http.get(`operations/running-commercial-loans/detail`).pipe(
            map((res: any) => res))
            // .catch((error: any) => Observable
            //     .throw(error.error || 'Server error'));
    }

    getMaturedInstructionType() {
        return this.http.get(`operations/maturity-instruction-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getMaturedLoanInstructions() {
        return this.http.get(`operations/loan-maturity-instructions`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addLoanMaturityInstruction(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`operations/approve-commercial-loan-maturity-instruction`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanChargeFeeByLoanId(loanId) {
        return this.http.get(`operations/loan-charge-fee-byloanid?loanId=${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    sendCommercialLoanRolloverInstruction(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/approve-commercial-loan-roll-over`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addTenor(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/non-term-loan-tenor-extension`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    loanOperationGoForApproval(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/application-go-for-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    LineGoForApproval(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/application-line-operation-go-for-approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addTenorToLine(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/application-line-tenor-extension`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    changeLineFacilityAmount(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/application-line-facility-amount-change`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    saveSubAllocations(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/commercial-loan-sub-allocation`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    addCommercialLoanPayment(data,loanReferenceNumber) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/commercial-loan-prepayment/${loanReferenceNumber}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    changeNonTermLoanInterestRate(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/non-term-loan-interest-rate-change`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    changeApplicationLineInterestRate(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/
        `, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    runInterestRateChange(data) {
        let bodyObj = JSON.stringify(data);
        return this.http.post(`operations/commercial-loan-interest-rate-change`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    //CAMSOL
    getAllCamsol() {
        return this.http.get(`camsol/loan-camsol`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllCamsolByCamsolTypeId(id) {
        return this.http.get(`camsol/view-loan-camsol-type/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    CamsolByCamsolAwaitingApprovalById(id) {
        return this.http.get(`camsol/camsol-approval-type/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllCamsolByCamsolAwaitngApproval() {
        return this.http.get(`camsol/loan-camsol-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllSearchCamsol(searchValue) {
        return this.http.get(`camsol/loan-camsol-search/${searchValue}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanCamsolType() {
        return this.http.get(`camsol/loan-camsol-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanCamsolTypeId(id) {
        return this.http.get(`camsol/loan-camsol-type-id/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanCamsolByCostomerCode(customercode) {
        return this.http.get(`camsol/loan-camsol-customer-code/${customercode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    goForCamsolApproval(data) {
        return this.http.post(`camsol/go-for-camsol-approval/`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    approveLoan(data) {
        return this.http.post(`camsol/approve-loan-camsol`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getProductType() {
        return this.http.get(`facilitydetailsummary/product-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanDetail(loanId) {
        return this.http.get(`facilitydetailsummary/loan-schedule/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getFacilityDetail(loanId) {
        return this.http.get(`facilitydetailsummary/facilty-details/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getContingentFacilityDetail(loanId) {
        return this.http.get(`facilitydetailsummary/contingent-facilty-details/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getOverdraftFacilityDetail(loanId) {
        return this.http.get(`facilitydetailsummary/overdraft-facilty-details/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanChargeFees(loanId) {
        return this.http.get(`facilitydetailsummary/loan-chargefee/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanConvenantDetail(loanId) {
        return this.http.get(`facilitydetailsummary/loan-convenant/${loanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateral(loanId,loanSystemTypeId) {
        return this.http.get(`facilitydetailsummary/loan-collateral/${loanId}/loanSystemType${loanSystemTypeId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanSearch(data) {
        return this.http.post(`facilitydetailsummary/loan-search`,data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    uploadCamsolFile(file: File, body: any) {
        // let bodyObj = JSON.stringify(body);
        return new Promise((resolve, reject) => {

            let url = `camsol/multiple-camsol-data`;
            // let url = `media/upload-file`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    }
    approveBulkCamsol(formObj) {
        let body = JSON.stringify(formObj);
        return this.http.post(`camsol/bulk-approval`, formObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    SendEmailForRecovery(accreditedConsultantId) {
        return this.http
            .get(`creditoperations/sent-email-for-recovery/${accreditedConsultantId}`,).pipe(
            map((res: any) => res));
    }

    GetfullAndFinalLoanStatus() {
        return this.http.get(`loan/full-and-final-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    GetContingAmountUsed(contingentLoanId) {
        return this.http
            .get(`credit/contingent-used-amount/${contingentLoanId}`).pipe(
            map((res: any) => res));
    }

    getApprovedLoanReviewRouteAndOperation() {
        return this.http
            .get(`creditoperations/approved-loan-review-route`).pipe(
            map((res: any) => res));
    }

    getThirdPartyFacility(loanReferenceNumber) {
        return this.http.get(`facilitydetailsummary/third-party-facilty-details/${loanReferenceNumber}`)
        .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }
    
}

